import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const response = await fetch('http://localhost:5002/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setSubmitStatus({ 
          type: 'success', 
          message: 'Thank you! Your message has been sent successfully.' 
        });
        // Reset form
        setFormData({
          name: '',
          email: '',
          organization: '',
          message: ''
        });
      } else {
        setSubmitStatus({ 
          type: 'error', 
          message: data.message || 'Failed to send message. Please try again.' 
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus({ 
        type: 'error', 
        message: 'Network error. Please check your connection and try again.' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const JOIN_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSeiIv15zCl8WpL3mhRijtHywB7MJzsMNwqTyTeNlm-zuiTCiw/viewform';
  const SUBSTACK_URL = 'https://substack.com/@womenineconpolicy';

  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1 className="contact-title">Get Started With Us</h1>

        <div className="contact-intro">
          <p className="contact-intro-text">
            Join our community of women in economics and policy! Fill out the form below to become part of Women in Econ/Policy.
          </p>
          <div className="contact-join-links">
            <a 
              href={JOIN_FORM_URL} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="contact-join-button"
            >
              Join the Group
            </a>
            <a 
              href={SUBSTACK_URL} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="contact-join-button contact-join-button-substack"
            >
              Sign up for our Substack
            </a>
          </div>
          <p className="contact-note">
            For other queries or to reach out for any other reason, please fill out this form.
          </p>
        </div>

        {submitStatus.message && (
          <div className={`submit-status ${submitStatus.type}`}>
            {submitStatus.message}
          </div>
        )}

        <form className="contact-form" onSubmit={handleSubmit}>
          {/* Name */}
          <div className="form-group">
            <label className="form-label">Name <span className="required">*</span></label>
            <input 
              type="text" 
              name="name"
              className="form-input" 
              value={formData.name}
              onChange={handleChange}
              required 
            />
          </div>

          {/* Email */}
          <div className="form-group">
            <label className="form-label">Email <span className="required">*</span></label>
            <input 
              type="email" 
              name="email"
              className="form-input" 
              value={formData.email}
              onChange={handleChange}
              required 
            />
          </div>

          {/* Organization */}
          <div className="form-group">
            <label className="form-label">Organization <span className="required">*</span></label>
            <input 
              type="text" 
              name="organization"
              className="form-input" 
              value={formData.organization}
              onChange={handleChange}
              required 
            />
          </div>

          {/* Message */}
          <div className="form-group">
            <label className="form-label">Message <span className="required">*</span></label>
            <textarea 
              rows={4} 
              name="message"
              className="form-textarea" 
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button 
            type="submit" 
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;


